import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
//import { LoginComponent } from './views/login/login.component';
import { LoginComponent } from './user/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { AdminDashboardComponent } from './admin/admin-dashboard/admin-dashboard.component';
import { AuthGuard } from './user/auth.guard';
import { DirectSupplierPoComponent } from './no-login/direct-supplier-po/direct-supplier-po.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'direct-supplier-po/:id',
    component: DirectSupplierPoComponent
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'admin',
        loadChildren: './admin/admin.module#AdminModule'
      },
      {
        path: 'companies',
        loadChildren: './company/company.module#CompanyModule'
      },
      {
        path: 'suppliers',
        loadChildren: './admin/supplier/supplier.module#SupplierModule'
      },{
        path: 'customers',
        loadChildren: './admin/customer/customer.module#CustomerModule'
      },
      {
        path: 'parts',
        loadChildren: './admin/parts/parts.module#PartsModule'
      },
      {
        path: 'orders',
        loadChildren: './admin/order/order.module#OrderModule'
      },
      {
        path: 'invoice',
        loadChildren: './admin/invoice/invoice.module#InvoiceModule'
      },
      {
        path: 'usermanagement',
        loadChildren: './usermanagement/usermanagement.module#UsermanagementModule'
      },
      {
        path: 'barcode',
        loadChildren: './admin/barcode/barcode.module#BarcodeModule'
      },
      {
        path: 'upload',
        loadChildren: './admin/upload/upload.module#UploadModule'
      },
      {
        path: 'reports',
        loadChildren: './reports/reports.module#ReportsModule'
      },
      {
        path: 'base',
        loadChildren: './views/base/base.module#BaseModule'
      },
      {
        path: 'buttons',
        loadChildren: './views/buttons/buttons.module#ButtonsModule'
      },
      {
        path: 'charts',
        loadChildren: './views/chartjs/chartjs.module#ChartJSModule'
      },
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'icons',
        loadChildren: './views/icons/icons.module#IconsModule'
      },
      {
        path: 'notifications',
        loadChildren: './views/notifications/notifications.module#NotificationsModule'
      },
      {
        path: 'theme',
        loadChildren: './views/theme/theme.module#ThemeModule'
      },
      {
        path: 'widgets',
        loadChildren: './views/widgets/widgets.module#WidgetsModule'
      }
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
